import templateUrl from 'emun.invoice/email-invoice-prompt.htm'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import modals from 'webmodals/modals'

export default (options) => {
    const $ctrl = this;
    return modals.open({
        size: options.size || 'md',
        templateUrl,
        bindToController: true,
        controller: function () {
            const $ctrl = this;
            basicController($ctrl);
            console.info('hey man', options);
            $ctrl.model = {
                invoiceNumber: options.invoiceNumber,
                from: options.from || $ctrl.$session.email,
                to: options.to || options.retailerEmail,
                subject: options.subject || $ctrl.$session.clientName + ' Invoice: ' + options.invoiceNumber,
                clientName: $ctrl.$session.clientName,
                //status: options.invoice.status
            };
            $ctrl.bus = new ServiceBus();
            $ctrl.title = options.title || 'Email Invoice: ' + options.invoiceNumber

            $ctrl.submit = function () {
                const $ctrl = this;
                $ctrl.emailSent = false;
                var invoiceNumbers = $ctrl.model.invoiceNumber.split(",");
                if (invoiceNumbers.length > 1) {
                    $ctrl.model.invoiceNumbers = invoiceNumbers;
                    $ctrl.bus.send('EmailInvoices.json', $ctrl.model)
                    .then(res => $ctrl.emailSent = true);
//                    .then(res => $ctrl.$close(res.data));
                } else {
                    $ctrl.bus.send('EmailInvoice.json', $ctrl.model)
                    .then(res => $ctrl.emailSent = true);
//                    .then(res => $ctrl.$close(res.data));
                }
            };
        },
        controllerAs: '$ctrl'
    }).result;
};